module.exports = __webpack_public_path__ + "img/1.574554e1.gif";